import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-end w-full mb-5 mt-5"
}
const _hoisted_2 = { class: "font-bold" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "chip-red font-semibold inline-block p-2" }, " Pending ", -1)
const _hoisted_7 = {
  class: "flex w-full justify-between pl-5",
  style: {"border-left":"1px solid #ECEFF1"}
}
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "mr-2 color-primary font-semibold" }, "Pindah Jadwal", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("i", {
  class: "pi pi-arrow-right text-base color-primary",
  "aria:haspopup": "true"
}, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "pi pi-info-circle text-sm color-blue-grey-darken-1 mr-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputIconRightGrey = _resolveComponent("InputIconRightGrey")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_ListCopyEditDel = _resolveComponent("ListCopyEditDel")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _component_DialogDetailResi = _resolveComponent("DialogDetailResi")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.$route.name !== 'transaksi-pengiriman-pending')
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", null, [
            _createVNode(_component_InputIconRightGrey, {
              modelValue: _ctx.inputSearch,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputSearch = $event)),
              placeholder: "Cari No Resi ...",
              onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.searchData(_ctx.inputSearch)), ["enter"])),
              icon: _ctx.$icon.svg.searchEva,
              type: _ctx.$enumBase.input.text
            }, null, 8, ["modelValue", "icon", "type"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_DataTable, {
      value: _ctx.data,
      onPage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onPage($event))),
      loading: _ctx.loading,
      totalRecords: _ctx.filters.totalRecords,
      paginator: true,
      rows: _ctx.$numbers.totalItemPerPage,
      class: "table-og",
      responsiveLayout: "scroll"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, { header: "Nomor Resi" }, {
          body: _withCtx((slotProps) => [
            _createVNode("p", {
              class: "font-bold hover-primary cursor-pointer",
              onClick: ($event: any) => (_ctx.onDetail(slotProps.data.Id))
            }, _toDisplayString(slotProps.data.Resi.toUpperCase()), 9, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, { header: "Total Koli" }, {
          body: _withCtx((slotProps) => [
            _createVNode("p", _hoisted_2, _toDisplayString(slotProps.data.TransPengirimanDetails.length), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, { header: "Tanggal Pending" }, {
          body: _withCtx((slotProps) => [
            _createVNode("p", _hoisted_3, _toDisplayString(_ctx.moment(slotProps.data.LastUpdate).format('DD MMMM YYYY')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, { header: "Agen Tujuan" }, {
          body: _withCtx((slotProps) => [
            _createVNode("p", _hoisted_4, _toDisplayString(slotProps.data.AgenTujuan.Nama), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Tanggal",
          style: { display: _ctx.route.name === 'transaksi-pengiriman-pending' ? 'none' : 'table-cell' }
        }, {
          body: _withCtx((slotProps) => [
            _createVNode("p", _hoisted_5, _toDisplayString(_ctx.moment(slotProps.data.LastUpdate).format('DD-MM-YYYY')), 1)
          ]),
          _: 1
        }, 8, ["style"]),
        _createVNode(_component_Column, { header: "Status" }, {
          body: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_Column, null, {
          body: _withCtx((slotProps) => [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", {
                class: "flex cursor-pointer",
                onClick: ($event: any) => (_ctx.onDetail(slotProps.data.Id))
              }, [
                _hoisted_8,
                _hoisted_9
              ], 8, ["onClick"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, null, {
          body: _withCtx((slotProps) => [
            (slotProps.data.Attribute1)
              ? _withDirectives((_openBlock(), _createBlock("i", _hoisted_10, null, 512)), [
                  [
                    _directive_tooltip,
                    slotProps.data.Attribute1,
                    void 0,
                    { bottom: true }
                  ]
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, null, {
          body: _withCtx((slotProps) => [
            _createVNode("div", null, [
              _createVNode("i", {
                class: "pi pi-ellipsis-h text-base cursor-pointer text-black",
                "aria:haspopup": "true",
                "aria-controls": "overlay_panel",
                onClick: ($event: any) => (_ctx.showDropDown($event, slotProps.data))
              }, null, 8, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "loading", "totalRecords", "rows"]),
    _createVNode(_component_OverlayPanel, {
      ref: "op",
      id: "overlay_panel"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ListCopyEditDel, {
          refund: _ctx.route.name === 'transaksi-pengiriman-pending' ? _ctx.route.meta.permission.update && _ctx.$checkIsRefund(_ctx.dataForm.TransPengirimanDetails) : _ctx.$checkIsRefund(_ctx.dataForm.TransPengirimanDetails),
          detail: true,
          onRefund: _cache[4] || (_cache[4] = ($event: any) => (_ctx.refund(_ctx.dataForm.Id))),
          onDetail: _cache[5] || (_cache[5] = ($event: any) => (_ctx.detail(_ctx.dataForm.Id)))
        }, null, 8, ["refund"])
      ]),
      _: 1
    }, 512),
    (_ctx.showDialogDetail)
      ? (_openBlock(), _createBlock(_component_DialogDetailResi, {
          key: 1,
          isRefund: _ctx.isRefund,
          idTrans: _ctx.Id,
          isShowDialog: _ctx.showDialogDetail,
          onReloadData: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getAllData())),
          onHideDialog: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showDialogDetail = false))
        }, null, 8, ["isRefund", "idTrans", "isShowDialog"]))
      : _createCommentVNode("", true)
  ]))
}